import { render, staticRenderFns } from "./click-to-view.vue?vue&type=template&id=3d922226&"
import script from "./click-to-view.vue?vue&type=script&lang=js&"
export * from "./click-to-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports